import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet, Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { Header } from '../../../../shared/components/header/header';
import { Footer } from '../../../../shared/components/footer/footer';
import { AuthModal } from '../../../../shared/components/auth-modal/auth-modal';
import { ShopCart } from '../../shop-cart/shop-cart';
import { Auth } from '../../../../core/services/auth.service';
import { LoginPrompt } from '../../../../core/services/login-prompt.service';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [RouterOutlet, CommonModule, Header, Footer, AuthModal, ShopCart, ToastModule],
  template: `
    <p-toast position="top-center" [life]="3200"></p-toast>

    <app-header (openLoginModal)="openModal()"></app-header>

    <app-auth-modal
      *ngIf="showAuthModal"
      [inviteToken]="inviteToken"
      (closeModal)="closeModal()"
      (inviteConsumed)="onInviteConsumed()">
    </app-auth-modal>

    <router-outlet></router-outlet>

    <app-footer *ngIf="showFooter"></app-footer>

    <app-shop-cart (requestLogin)="openModal()"></app-shop-cart>
  `
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  showFooter: boolean = false;
  showAuthModal: boolean = false;
  inviteToken: string | null = null;
  private promptSub?: Subscription;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private auth: Auth,
    private loginPrompt: LoginPrompt,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.checkFooterStatus(this.router.url);
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.checkFooterStatus(event.urlAfterRedirects || event.url);
      this.checkInviteFromUrl();
    });
    this.checkInviteFromUrl();

    this.promptSub = this.loginPrompt.prompts$.subscribe((req) => {
      this.messageService.add({
        severity: 'warn',
        summary: req.summary,
        detail: req.detail,
        life: 3500
      });
      this.openModal();
    });
  }

  ngOnDestroy() {
    this.promptSub?.unsubscribe();
  }

  private checkFooterStatus(url: string) {
    this.showFooter = url !== '/';
  }

  private checkInviteFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('invite');
    if (!token) return;

    if (this.auth.isLoggedIn()) {
      this.clearInviteFromUrl();
      return;
    }

    this.inviteToken = token;
    this.showAuthModal = true;
  }

  onInviteConsumed(): void {
    this.clearInviteFromUrl();
  }

  private clearInviteFromUrl(): void {
    this.inviteToken = null;
    const params = new URLSearchParams(window.location.search);
    if (!params.has('invite')) return;

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { invite: null },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  openModal() {
    this.showAuthModal = true;
  }

  closeModal() {
    this.showAuthModal = false;
    this.clearInviteFromUrl();
  }
}
